import { render } from "./CCHome.vue?vue&type=template&id=0cb80c87&scoped=true&ts=true"
import script from "./CCHome.vue?vue&type=script&lang=ts"
export * from "./CCHome.vue?vue&type=script&lang=ts"

import "./CCHome.vue?vue&type=style&index=0&id=0cb80c87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb80c87"]])

export default __exports__